import { BehaviorSubject, Observable, map, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';

import { SiteContext, SiteContextParamsService } from '@spartacus/core';

import { BrandsEnum } from '@seb/web-design-system/core';

import { BaseStoreService } from './base-store.service';
import { CUSTOM_BRAND } from '../constants';
import { BrandsCorner } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CustomBrandService implements SiteContext<string> {
  private readonly activeBrand$ = new BehaviorSubject<string>(BrandsEnum.default);

  get activeBrand() {
    return this.activeBrand$.value;
  }

  constructor(
    private readonly paramsService: SiteContextParamsService,
    private readonly baseStoreService: BaseStoreService
  ) {}

  setActive(brand: string): void {
    const newBrand = brand.toLowerCase();

    if (newBrand !== this.activeBrand) {
      if (this.paramsService.getParamValues(CUSTOM_BRAND)?.find((id) => id === newBrand)) {
        this.activeBrand$.next(newBrand);
      }
    }
  }

  getAll(): Observable<string[]> {
    return this.baseStoreService.getBaseStore().pipe(
      map(({ houseOfBrandConfig }) => houseOfBrandConfig?.brand?.map(({ id }) => id.toLowerCase()))
    );
  }

  getActive(): Observable<string> {
    return this.baseStoreService.getBaseStore().pipe(
      switchMap(({ brandSite }) => {
        const brandSystem = brandSite.toLowerCase();
        return this.activeBrand$.pipe(
          map((active) => (
            (active && (active !== brandSystem)) ? active : BrandsEnum.default
          ))
        );
      })
    );
  }

  getFullBrands(): Observable<BrandsCorner[] | undefined> {
    return this.baseStoreService.getBaseStore().pipe(
      map(({ houseOfBrandConfig }) => houseOfBrandConfig?.brand)
    );
  }
}
